import { AsyncStoreItem } from '@lib';
import { PostStandbyGetAlternativeOffersResponse } from 'src/sdk_checkin';

/**
 * StandbyGetAlternativeOffers model
 */
export interface StandbyGetAlternativeOffersModel {
  model: PostStandbyGetAlternativeOffersResponse | null;
}

/**
 *  model details
 */
export interface StandbyGetAlternativeOffersStateDetails extends AsyncStoreItem {}

/**
 * StandbyGetAlternativeOffers store state
 */
export interface StandbyGetAlternativeOffersState
  extends StandbyGetAlternativeOffersStateDetails,
    StandbyGetAlternativeOffersModel {}

/**
 * Name of the StandbyGetAlternativeOffers Store
 */
export const STANDBY_GET_ALTERNATIVE_OFFERS_STORE_NAME = 'standbyGetAlternativeOffers';

/**
 * StandbyGetAlternativeOffers Store Interface
 */
export interface StandbyGetAlternativeOffersStore {
  /** StandbyGetAlternativeOffers state */
  [STANDBY_GET_ALTERNATIVE_OFFERS_STORE_NAME]: StandbyGetAlternativeOffersState;
}
